import 'reflect-metadata';
import {Service} from 'typedi';
import type {CardTypeStrategyData} from '../../types/card-strategy-data.type';
import {StrategyBuilder} from '../../StrategyBuilder';
import {CardStrategyService} from '../../CardStrategyService';
import type { ExstUnionUiModel } from '../../../../models/ui/documents/exchange/exst-union-ui.model';


@Service({id: 'exstCardStrategyService'})
export class ExstCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details:CardTypeStrategyData): CardStrategyService {
      return new ExstCardStrategyService(details);
  }
}


export class ExstCardStrategyService extends CardStrategyService {
  details;
  constructor(details:CardTypeStrategyData) {
      super();
      this.details = details;
  }

  makeCard(doc: ExstUnionUiModel): string {
      if(!this.details.params.source)
      {
        if(/EXST-Lithium-Community/i.test(doc.engineDetails.collection))
        {
          return 'uiaas-search-result-community';
        }
        else if(/^EXST-Products/i.test(doc.engineDetails.collection))
        {
          return 'uiaas-search-result-digital-product';
        }
        else if(/document\/exst\/sdlPage/i.test(doc.type))
        {
          return 'uiaas-search-result-developer-portal';
        }
        else
        {
          return 'uiaas-search-result-basic-v2';
        }
      }
      else
      {
        if(this.details.params.source === 'products') {
          return 'uiaas-search-result-digital-product';
        } else if(this.details.params.source === 'community') {
          return 'uiaas-search-result-community';
        } else if(this.details.params.source === 'developerResources') {
          return 'uiaas-search-result-developer-portal';
        } else if(this.details.params.source === 'drupal') {
          return 'uiaas-search-result-basic-v2';
        }
      }
  }

  getCardProps(doc: ExstUnionUiModel, params:Record<string, string>): Record<string,string>{
      if (this.details?.params) {
        return this.details.params;
      } return {};
  }
};
